export const pathData = `
  M70.7207 124C101.516 120.263 125.374 94.0317 125.374 62.2281C125.374
  27.8605 97.5137 0 63.1461 0C28.7784 0 0.917969 27.8605 0.917969
  62.2281C0.917969 86.0024 14.2503 106.663 33.8462 117.141C34.572
  114.679 34.7923 111.364 34.7923 106.804V67.2747C34.7923 67.2747
  33.2134 61.5787 24.5821 59.5847C24.1841 59.4946 23.8947 59.1488
  23.8947 58.7433V54.108C23.8947 53.7648 24.0981 53.4538 24.4126
  53.3151L55.9696 39.4275C57.9439 38.7186 60.0102 40.2273 59.9303
  42.3183L59.5445 55.7744C65.27 47.6685 76.3535 39.3798 86.5134
  39.3798C97.4109 39.3798 102.398 46.9311 102.398 55.9573C102.398
  64.4306 97.4109 70.8787 89.6529 70.8787C82.8186 70.8787 80.2326
  67.1941 78.3852 63.5103C77.0922 60.3785 75.7991 57.4313 71.1815
  57.4313C67.1174 57.4313 63.4235 60.1939 60.098 66.0883V106.804C60.098
  118.669 61.7558 122.105 70.7207 124Z`;
